function fixNum(value, n) {
  let realVal = '';
  if (!isNaN(value) && value !== '') {
    // 截取当前数据到小数点后两位
    realVal = parseFloat(value).toFixed(n);
  } else {
    realVal = '--';
  }
  return realVal;
}

function fixNum2(value) {
  let realVal = '';
  if (!isNaN(value) && value !== '') {
    // 截取当前数据到小数点后两位
    realVal = parseFloat(value).toFixed(2);
  } else {
    realVal = '--';
  }
  return realVal;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default { fixNum, fixNum2 };
